import { render, staticRenderFns } from "./CustomerActAddNew.vue?vue&type=template&id=4c5d8ee7&"
import script from "./CustomerActAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerActAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports